<app-auth-layout>

  <h2>¡Ya casi estamos listos!</h2>
  <h6>Antes de continuar necesitamos completes tus siguientes datos:</h6>
  <br>

  <mat-stepper linear #stepper orientation="vertical">
    <mat-step [stepControl]="primerFormGroup">
      <form [formGroup]="primerFormGroup">
        <ng-template matStepLabel>Titular</ng-template>
        <br>
        <div class="row">
          <div class="col">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Nombre</mat-label>
              <input matInput type="text" formControlName="Nombre" [disabled]="nombreDisabled" />

              <button mat-icon-button matSuffix (click)="habilitarNombre()" type="button">
                <mat-icon>edit</mat-icon>
              </button>

              <mat-error *ngIf="primerFormGroup.controls['Nombre'].hasError('required')">
                El nombre es <strong>requerido</strong>
              </mat-error>
              <mat-error *ngIf="primerFormGroup.controls['Nombre'].hasError('maxlength')">
                Superó el máximo de caracteres.
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Numero de celular</mat-label>
              <input matInput type="text" formControlName="Telefono" />
              <mat-error *ngIf="primerFormGroup.controls['Telefono'].hasError('required')">El nombre es
                <strong>requerido</strong>
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <mat-checkbox formControlName="TerminosCondiciones" class="example-disabled-checkbox">
              Terminos y condiciones</mat-checkbox>
            <mat-error *ngIf="primerFormGroup.controls['TerminosCondiciones'].hasError('requiredTrue')">Debe aceptar
              los terminos y condiciones.
            </mat-error>
          </div>
        </div>
        <br>
        <div>
          <button mat-stroked-button matStepperNext>Siguiente</button>
        </div>
      </form>
    </mat-step>
    <mat-step [stepControl]="segundoFormGroup">
      <form [formGroup]="segundoFormGroup">
        <ng-template matStepLabel>Su empresa</ng-template>
        <br>
        <div>
          <button mat-button matStepperPrevious>Volver</button>
          <button mat-stroked-button matStepperNext>Siguiente</button>
        </div>
      </form>
    </mat-step>
    <mat-step>
      <ng-template matStepLabel>Finalizar</ng-template>
      <p>Ya estás listo.</p>
      <br>
      <div>
        <button mat-button matStepperPrevious>Volver</button>
        <button mat-stroked-button (click)="stepper.reset()">Reiniciar</button>
        <button mat-raised-button>Finalizar</button>
      </div>
    </mat-step>
  </mat-stepper>
</app-auth-layout>
